// @flow
import * as React from "react";

import { THEME_RED } from "../../commons/theme";

type Props = {
  name: string,
  email: string,
  tel: string,

  onChange: (e: SyntheticEvent<HTMLInputElement>) => any,
  onClickConfirm: () => any
};

const STYLE_INPUT = {
  width: "100%",
  border: "none"
};

const STYLE_LEFT_CELL = {
  textAlign: "right",
  paddingRight: 4
};

const Form = ({ name, email, tel, onChange, onClickConfirm }: Props) => {
  return (
    <div>
      <p>Veuillez renseigner vos coordonnées ci-dessous</p>
      <table style={{ width: "100%" }}>
        <tbody>
          <tr>
            <td style={STYLE_LEFT_CELL}>Nom</td>
            <td>
              <input
                data-id="name"
                type="text"
                style={STYLE_INPUT}
                value={name}
                onChange={onChange}
              />
            </td>
          </tr>
          <tr>
            <td style={STYLE_LEFT_CELL}>Email</td>
            <td>
              <input
                data-id="email"
                type="text"
                style={STYLE_INPUT}
                value={email}
                onChange={onChange}
              />
            </td>
          </tr>
          <tr>
            <td style={STYLE_LEFT_CELL}>
              Téléphone
              <span
                style={{
                  marginLeft: 5,
                  fontStyle: "italic",
                  fontSize: 12
                }}
              >
                (facultatif)
              </span>
            </td>
            <td>
              <input
                data-id="tel"
                type="text"
                style={STYLE_INPUT}
                value={tel}
                onChange={onChange}
              />
            </td>
          </tr>
        </tbody>
      </table>

      <div style={{ textAlign: "center" }}>
        <button
          style={{
            display: "inline-block",
            cursor: "pointer",
            border: "none",
            margin: "20px 0",
            padding: 20,
            width: 115,
            color: "#FFF",
            fontWeight: "bold",
            borderRadius: 5,
            background: THEME_RED,
            textAlign: "center"
          }}
          onClick={onClickConfirm}
        >
          Commander
        </button>
      </div>

      <p style={{ textAlign: "right" }}>
        Franco de port en France métropolitaine à partir de 12 bouteilles
      </p>
    </div>
  );
};

export default Form;



// WEBPACK FOOTER //
// ./src/NosBouteilles/OrderCompletion/Form.js